<div [formGroup]="formArray.controls[group]">
    <targeting-container label="Geo Targeting" (onEdit)="openSidebar()" (onRemove)="removeAllItem(selectedRegions)"
        [disabled]="isDisabled">
        <div class="geo-targeting-section" id="geo-targeting">
            <span class="font-weight-bold mr-2">Continents, countries, regions, DMAs and cities:</span>
            <div class="d-inline" *ngIf="selectedRegions.length !== 0" [class.disabled]="isDisabled">
                <span class="chip-container" [ngClass]="isDisabled ? 'hide-chip-close-button' : 'cursor-pointer'"
                    *ngFor="let item of selectedRegions">
                    <acl-ngx-tooltip [trigger]="trigger" [text]="getFullyQualifiedName(item)">
                    </acl-ngx-tooltip>
                    <ng-template #trigger>
                        <acl-ngx-chip [text]="getItemName(item)" (onClose)="removeItem(item)">
                        </acl-ngx-chip>
                    </ng-template>
                </span>
            </div>
            <div *ngIf="targetedRegions.errors && targetedRegions.errors.required" class="error-feedback">
                A geo targeting selection is required
            </div>
            <acl-ngx-flyout [open]="open" (close)="cancel()" portalRoot="geo-targeting">
                <acl-ngx-flyout-header title="Geographic Targeting" (close)="cancel()">
                </acl-ngx-flyout-header>
                <acl-ngx-flyout-body>
                    <div>
                        <div class="control-group geographic-tree include-tree">
                            <!-- TODO: Search component -->
                            <ul class="main-list unstyled" [checkbox-tree]="continentsInSideBar"
                                [expand]="expand.bind(this)" [change]="changed.bind(this)">
                            </ul>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-9 border-right font-weight-bold">
                                <div class="m-1">Include</div>
                            </div>
                            <div class="col-3 reset-container">
                                <acl-ngx-button label="Reset" [disabled]="!selectedRegionsInSideBar.length"
                                    [compact]="true" variant="static" (click)="removeAllItem(selectedRegionsInSideBar)">
                                </acl-ngx-button>
                            </div>
                        </div>
                        <hr>
                        <div *ngIf="selectedRegionsInSideBar.length !== 0">
                            <span class="chip-container" *ngFor="let item of selectedRegionsInSideBar">
                                <acl-ngx-tooltip [trigger]="trigger" [text]="getFullyQualifiedName(item)">
                                </acl-ngx-tooltip>
                                <ng-template #trigger>
                                    <acl-ngx-chip [text]="getItemName(item)" (onClose)="removeItem(item)">
                                    </acl-ngx-chip>
                                </ng-template>
                            </span>
                        </div>
                    </div>
                </acl-ngx-flyout-body>
                <acl-ngx-flyout-footer [leftButton]="saveButton" [rightButton]="cancelButton"></acl-ngx-flyout-footer>
            </acl-ngx-flyout>
        </div>
    </targeting-container>
</div>